import React from 'react';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import Button from 'ls-common-client/dist/components/Button';
import Image from '../Image';

const StyledRoot = styled(Container)`
  max-width: 1300px;
  margin: 0 auto;
  width: 100%;
  padding: 120px 30px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-evenly;
  @media (max-width: 1024px) {
    padding: 80px 30px;
  }
  @media (max-width: 767px) {
    padding: 16px 30px 40px 30px;
    text-align: center;
    flex-direction: column;
  }
`;

const StyledGraphic = styled(Container)`
  max-width: 435px;
  text-align: center;
  img {
    max-width: 100%;
  }
  @media (max-width: 767px) {
    max-width: 100%;
    margin: 40px 0;
    img {
      max-width: 270px;
    }
  }
`;

const StyledText = styled(Container)`
  max-width: 351px;
  margin-right: 88px;
  h1 {
    font-size: 48px;
    font-weight: bold;
    max-width: 350px;
    line-height: 1.2em;
    margin-bottom: 26px;
    @media (max-width: 767px) {
      font-size: 22px;
      max-width: 269px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  p {
    font-size: 18px;
    color: #757575;
    max-width: 350px;
    margin-bottom: 30px;
    @media (max-width: 767px) {
      max-width: 260px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media (max-width: 767px) {
    margin-right: 0;
    max-width: unset;
  }
`;

const StyledButton = styled(Button)`
  max-width: 228px;
  background: #ffffff;
  &:hover {
    background: ${props => props.theme.primary.normal};
    border-color: ${props => props.theme.primary.normal};
    color: #ffffff;
  }
`;

const UserEmptyLayout = ({
  graphic,
  graphicFallback,
  heading,
  text,
  buttonText,
  onClick,
}) => {
  return (
    <StyledRoot>
      <StyledGraphic>
        <Image
          src={graphic}
          fallback={graphicFallback}
          alt="Localsearch user management"
          width="392"
        />
      </StyledGraphic>
      <StyledText>
        <h1>{heading}</h1>
        <p>{text}</p>
        {!!buttonText && !!onClick && (
          <StyledButton onClick={onClick} rounded border primary>
            {buttonText}
          </StyledButton>
        )}
      </StyledText>
    </StyledRoot>
  );
};

export default UserEmptyLayout;
